import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-salesforce-interactions',
  templateUrl: './salesforce-interactions.component.html',
  styleUrls: ['./salesforce-interactions.component.scss'],
})
export class SalesforceInteractionsComponent {
  @Input() org: any;
  @Input() interactions: { events: any[]; tasks: any[] } = { events: [], tasks: [] };
}
